import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

// Register Chart.js components
ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const DevicePackage = ({ Dashdata }) => {
  // Fallback if no data
  //console.log(Dashdata  )
  const taken = Dashdata?.total_devices || 0;
  const applied = Dashdata?.licensed_devices || 0;
  const remaining = Dashdata?.unlicensed_devices || 0;
  const total = taken; // total taken = applied + remaining (as per API)

  // Chart data
  const data = {
    labels: ["Applied", "Pending"],
    datasets: [
      {
        data: [applied, remaining],
        backgroundColor: ["#FF6B00", "#FF8740"],
        borderWidth: 0,
      },
    ],
  };

  // Chart options
  const options = {
    cutout: "70%", // Donut thickness
    plugins: {
      legend: { display: false },
      datalabels: {
        display: false, // Hide data labels
      },
      tooltip: {
        enabled: true,
        callbacks: {
          label: (context) => {
            const label = context.label || "";
            const value = context.raw || 0;
            return `${label}: ${value}`;
          },
        },
      },
    },
    maintainAspectRatio: false,
  };

  return (
    <div className="bg-white rounded-xl p-4 w-full max-w-[262px] h-full flex flex-col justify-between shadow-md hover:shadow-lg transition-all duration-300">
      {/* Title */}
      <h2
        className="text-base font-semibold mb-3"
        style={{
          color: "#595C60",
          fontFamily: "Nunito Sans, sans-serif",
          fontWeight: 600,
        }}
      >
        Total Devices: {total}
      </h2>

      <div className="flex flex-col items-start">
        {/* Donut Chart */}
        <div className="w-32 h-32 self-center">
          <Doughnut data={data} options={options} />
        </div>

        {/* License Details */}
        <ul className="text-base space-y-1 mt-4 w-full">
          <li className="flex justify-between">
            <span className="font-semibold" style={{ color: "#FF6B00" }}>
              Applied
            </span>
            <span>{applied}</span>
          </li>
          <li className="flex justify-between">
            <span className="font-semibold" style={{ color: "#FF8740" }}>
              Pending
            </span>
            <span>{remaining}</span>
          </li>
          <li className="flex justify-between border-t pt-1 mt-1">
            <span className="font-semibold" style={{ color: "#595C60" }}>
              Total Devices
            </span>
            <span>{taken}</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default DevicePackage;
